import React from 'react'

import styles from './styles.module.scss'

const Checkbox = ({ customClassName, ...props }) => (
  <input type='checkbox' className={`${styles.checkbox} ${customClassName}`} {...props} />
)

export default Checkbox
